export default "__VITE_ASSET__BDfYi_xb__"